import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"


export const GET_USER_VALID = "GET_USER_VALID";
export const GET_MY_REQUEST_SHC = "GET_MY_REQUEST_SHC";
export const GET_MY_REQUEST_STATUS ="GET_MY_REQUEST_STATUS";
export const GET_AGENDAS = "GET_AGENDAS";
export const GET_AGENDAS2 = "GET_AGENDAS2";
export const ADD_REQUEST ="ADD_REQUEST";
export const ADD_BASE64 ="ADD_BASE64";
export const SHC_LOADING = "SHC_LOADING";
export const SHC_LOADING_INI = "SHC_LOADING_INI";
export const GET_EMPLO_STATUS = "GET_EMPLO_STATUS";

  const instance = axios.create({
    baseURL: process.env.REACT_APP_AYB_API_SHC_URL,
    withCredentials: false,
    headers: {
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      }
  });

  function formatAMPM(time) {
    if(time != ''){
      console.log(time);
      var hours = parseInt(time.split(':')[0]);
      var minutes =parseInt(time.split(':')[1]);
  
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }
    else{
      return ''
    }
  }

  export const getUserValid = (badge) => {
    var Token = convertSHA()
    return async  dispatch =>{
      dispatch({
        type: SHC_LOADING_INI
      });
      await instance.get(`/Agendas/GetUserValid?badge=${badge}&token=${Token}`).then((res => {
          dispatch({
              type: GET_USER_VALID,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getRequestStatus = (badge) => {
    var Token = convertSHA()
    return async  dispatch =>{
      dispatch({
        type: SHC_LOADING
      });//
      await instance.get(`/Agendas/GetMyRequestChatBot?badge=${badge}&top=1&token=${Token}`).then((res => {
      //await instance.get(`/Agendas/GetStatusEmployee?badge=${badge}&token=${Token}`).then((res => {
          dispatch({
              type: GET_MY_REQUEST_STATUS,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getEmplotStatus = (badge) => {
    var Token = convertSHA()
    return async  dispatch =>{
      dispatch({
        type: SHC_LOADING
      });//
      await instance.get(`/Agendas/GetStatusEmployee?badge=${badge}&token=${Token}`).then((res => {
          dispatch({
              type: GET_EMPLO_STATUS,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getMyRequestSHC = (badge) => {
    var Token = convertSHA()
    return async  dispatch =>{
      dispatch({
        type: SHC_LOADING
      });//
      //await instance.get(`/Agendas/GetMyRequestChatBot?badge=${badge}&top=2&token=${Token}`).then((res => {
      await instance.get(`/Agendas/GetMyRequestChatBot?badge=${badge}&top=1&token=${Token}`).then((res => {
          dispatch({
              type: GET_MY_REQUEST_SHC,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const getAgendas = (badge,horaInicio,diasLibres,permanencia) => {
    var Token = convertSHA()
    return async  dispatch =>{
      dispatch({
        type: SHC_LOADING
      });//
      //await instance.get(`/Agendas/GetMyRequestChatBot?badge=${badge}&top=2&token=${Token}`).then((res => {
      await instance.get(`/Agendas/GetAgendas?badge=${badge}&horaInicio=${horaInicio}&diasLibres=${diasLibres}&permanencia=${permanencia}&token=${Token}`).then((res => {
          dispatch({
              type: GET_AGENDAS,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };
  export const getAgendasLoad = (badge) => {
    var Token = convertSHA()
    return async  dispatch =>{
      dispatch({
        type: SHC_LOADING
      });//
      //await instance.get(`/Agendas/GetMyRequestChatBot?badge=${badge}&top=2&token=${Token}`).then((res => {
      await instance.get(`/Agendas/GetAgendasException?badge=${badge}&token=${Token}`).then((res => {
          dispatch({
              type: GET_AGENDAS2,
              data: res.data
              });
        console.log("Resp", res);
        }
        )).catch(function(error){
          console.log("Error", error);
        });
    } 
  };

  export const insertRequest= (badge,user,Employee,form,agenda,custom,status) => {
    var Token = convertSHA()
    var params ="";
    if(!form.Custom){
      params = JSON.stringify({
        "StatusID": 1,
        "Employee_ID": badge,
        "Network_Login": user,
        "ProblemID": (form.permanente.id)?1:2,
        "ReasonID": 4,
        "Schedule_ID": agenda.ID,
        "StartDate": agenda.Until,
        "FinalDate": "2022-10-13T01:42:04.109Z",
        "Type": status,
        "token": Token,
        "HorariosCustom": null,
        "Employee_Email": form.email,
        "Employee_Name": Employee,
        });
    }
    else{
      params = JSON.stringify({
        "StatusID": 1,
        "Employee_ID": badge,
        "Network_Login": user,
        "ProblemID": 7,
        "ReasonID": form.razon.id,
        "Schedule_ID": 0,
        "StartDate": custom.Until,
        "FinalDate": custom.Until,
        "Type": status,
        "token": Token,
        "HorariosCustom": {
          "MondayIn": formatAMPM(custom.MondayIn),
          "MondayOut": formatAMPM(custom.MondayOut),
          "ThuesdayIn": formatAMPM(custom.ThuesdayIn),
          "ThuesdayOut": formatAMPM(custom.ThuesdayOut),
          "WednesdayIn": formatAMPM(custom.WednesdayIn),
          "WednesdayOut": formatAMPM(custom.WednesdayOut),
          "ThursdayIn": formatAMPM(custom.ThursdayIn),
          "ThursdayOut": formatAMPM(custom.ThursdayOut),
          "FridayIn": formatAMPM(custom.FridayIn),
          "FridayOut": formatAMPM(custom.FridayOut),
          "SaturdayIn": formatAMPM(custom.SaturdayIn),
          "SaturdayOut": formatAMPM(custom.SaturdayOut),
          "SundayIn": formatAMPM(custom.SundayIn),
          "SundayOut": formatAMPM(custom.SundayOut),
          "TotalHours": custom.TotalHours
        },
        "Employee_Email": form.email,
        "Employee_Name": Employee,
        });
    }
    
    const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'application/json' } }
    return async dispatch => {
      dispatch({
        type: SHC_LOADING
      });
      //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
      await instance.post(`/Agendas/PostInsertaRequest`, params, config).then((res => {
        dispatch({
          type: ADD_REQUEST,
          data: res.data
        });
        console.log(res);
      })).catch(function (error) {
        console.log("Error", error);
      });
    }
  }

  export const insertRequestException= (badge,user,Employee,form,agenda,custom,status) => {
    var Token = convertSHA()
    var params ="";
    if(!form.Custom){
      params = JSON.stringify({
        "StatusID": 1,
        "Employee_ID": badge,
        "Network_Login": user,
        "ProblemID": (form.permanente.id)?1:2,
        "ReasonID": 4,
        "Schedule_ID": agenda.ID,
        "StartDate": agenda.Until,
        "FinalDate": "2022-10-13T01:42:04.109Z",
        "Type": status,
        "token": Token,
        "HorariosCustom": null,
        "Employee_Email": form.email,
        "Employee_Name": Employee,
        });
    }
    else{
      params = JSON.stringify({
        "StatusID": 1,
        "Employee_ID": badge,
        "Network_Login": user,
        "ProblemID": 7,
        "ReasonID": form.razon.id,
        "Schedule_ID": 0,
        "StartDate": custom.Until,
        "FinalDate": custom.Until,
        "Type": 0,
        "token": Token,
        "HorariosCustom": {
          "MondayIn": formatAMPM(custom.MondayIn),
          "MondayOut": formatAMPM(custom.MondayOut),
          "ThuesdayIn": formatAMPM(custom.ThuesdayIn),
          "ThuesdayOut": formatAMPM(custom.ThuesdayOut),
          "WednesdayIn": formatAMPM(custom.WednesdayIn),
          "WednesdayOut": formatAMPM(custom.WednesdayOut),
          "ThursdayIn": formatAMPM(custom.ThursdayIn),
          "ThursdayOut": formatAMPM(custom.ThursdayOut),
          "FridayIn": formatAMPM(custom.FridayIn),
          "FridayOut": formatAMPM(custom.FridayOut),
          "SaturdayIn": formatAMPM(custom.SaturdayIn),
          "SaturdayOut": formatAMPM(custom.SaturdayOut),
          "SundayIn": formatAMPM(custom.SundayIn),
          "SundayOut": formatAMPM(custom.SundayOut),
          "TotalHours": custom.TotalHours
        },
        "Employee_Email": form.email,
        "Employee_Name": Employee,
        });
    }
    
    const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'application/json' } }
    return async dispatch => {
      dispatch({
        type: SHC_LOADING
      });
      //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
      await instance.post(`/Agendas/PostUpdateRequestScheduleException`, params, config).then((res => {
        dispatch({
          type: ADD_REQUEST,
          data: res.data
        });
        console.log(res);
      })).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
  export const insertBase64 = (user,Imagen,request) => {
    var Token = convertSHA()
    var img64 = Imagen.split(",")[1];
    var params =JSON.stringify({
      "Imagen": img64,
      "NetworkLogin": user,
      "request": request,
      "token": Token
    });
    
    const config = { headers: { 'Access-Control-Allow-Origin': '*','content-type': 'application/json' } }
    return async dispatch => {
      dispatch({
        type: SHC_LOADING
      });
      //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
      await instance.post(`/Agendas/PostBase64ToImage`, params, config).then((res => {
        dispatch({
          type: ADD_BASE64,
          data: res.data
        });
        console.log(res);
      })).catch(function (error) {
        console.log("Error", error);
      });
    }
  }